import { formatValidQueryParamUrlCommaSeparated } from "utils/common";
import { sunoCommsApi } from "./api-base";
import {
  type CallLog,
  type CallLogsFilter,
  type CallLogsResponse,
} from "./types/call-log.type";

export const DEFAULT_CALL_LOGS_LIMIT = 30;

const callLogsApi = sunoCommsApi.injectEndpoints({
  endpoints: (builder) => ({
    getCallLogs: builder.query<CallLogsResponse, CallLogsFilter>({
      query: (filters) => {
        const params = {
          practice_id: filters.practice_id,
          contact_oms_ids: filters.contact_oms_ids,
          direction: filters.direction,
          status: filters.status,
          limit: filters.limit,
          skip: filters.offset,
        };

        const date_range =
          filters.from_date || filters.to_date
            ? `${
                filters.from_date
                  ? new Date(filters.from_date).toISOString()
                  : ""
              },${
                filters.to_date ? new Date(filters.to_date).toISOString() : ""
              }`
            : undefined;

        return `/calls/${formatValidQueryParamUrlCommaSeparated(
          { ...params, date_range },
          true
        )}`;
      },
      providesTags: ["CallLogs"],
    }),
    getCallLog: builder.query<CallLog | undefined, string>({
      query: (id) => `/calls/?ids=${id}&include_transcription=true&limit=1`,
      transformResponse: (response: CallLog[]) =>
        Array.isArray(response) ? response?.at(0) : undefined,
      providesTags: ["CallLogs"],
    }),
    getCallLogByCallSid: builder.query<CallLog | undefined, string>({
      query: (call_sids) => `/calls/?call_sids=${call_sids}`,
      transformResponse: (response: CallLog[]) =>
        Array.isArray(response) ? response?.at(0) : undefined,
      providesTags: ["CallLogs"],
    }),
  }),
});

export const {
  useGetCallLogsQuery,
  useGetCallLogQuery,
  useGetCallLogByCallSidQuery,
} = callLogsApi;
